import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { MdDialog } from '@angular/material';
import { FormGroup, FormBuilder } from "@angular/forms";
import { ApplyStatusService } from '../../services/apply-status.service';
import {MdCheckboxModule} from '@angular/material';
import { DocListAnswerService } from '../../services/doc-list-answer.service';
import { ApplyService } from '../../services/apply.service';
import { Constants } from '../constants';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-check-doc-list',
  templateUrl: './check-doc-list.component.html',
  styleUrls: ['./check-doc-list.component.css']
})
export class CheckDocListComponent implements OnInit {

  jobId: string;
  userId: string;
  job: JobsOffer;
  user: any;
  query:string = '';
  form: FormGroup;
  page:number = null; 

  doclistall:any;
  pagination:any;

  errorMessage: string;

  loading_job: boolean = true;

  public STATUS = Constants;

  constructor(
    private route: ActivatedRoute,
    private jobService: JobOffersService,
    private dialog: MdDialog,
    private fb: FormBuilder,
    
    private applyStatusService: ApplyStatusService,
    private ApplyService: ApplyService,
    private docListAnswerService: DocListAnswerService
  ) { }

  ngOnInit() {
    if(!this.page){
      this.page = 1;
    }
    this.form = this.fb.group({
      query: [''],
    });
    // TODO: get users invite to jobId
    this.docListAnswerService.getAllDocList(this.query, this.page).subscribe((data:any) => {
      this.pagination = data.pagination;
      this.doclistall = data.doclists;
      this.loading_job = false;
    });
  }
  updateFilters(value, valid){
    if(valid){
      this.query = value.query;
      this.docListAnswerService.getAllDocList(this.query, this.page).subscribe(
        (data:any) => {
        this.pagination = data.pagination;
        this.doclistall = data.doclists;
        this.loading_job = false;
        });
    }
  }
  refreshListing(page: number) {
    this.loading_job = true;
    this.page = page;
    this.docListAnswerService.getAllDocList(this.query, this.page).subscribe(
      (data:any) => {
        this.pagination = data.pagination;
        this.doclistall = data.doclists;
        this.loading_job = false;
      });
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Verificación de Documentos', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/check-doc-list/check-doc-list.component.ts